import clsx from 'clsx'
import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './Chip.module.scss'

export interface ChipProps extends PropsWithChildren {
  backgroundColor?: string
  className?: string
  color?: string | 'grey' | 'error' | 'red' | 'black' | 'yellow' | 'blue' | 'greyV2'
  size?: string | 'small' | 'medium'
  style?: CSSProperties
  textColor?: string
}

export const Chip: FC<ChipProps> = ({
  backgroundColor,
  children,
  className,
  color,
  size,
  style: styleProperty = {},
  textColor,
}) => {
  const style = {
    '--chipTextColor': textColor,
    '--chipBackgroundColor': backgroundColor,
    ...styleProperty,
  } as CSSProperties
  const saleTagTest = useSplitTest('sale_tag_v1', 'b')
  const lateSeasonSvgTag = useSplitTest('late_season_svg_tag_v1', 'b')

  if (color === 'summersale') {
    return <img alt="Summer Sale" className={clsx(styles.svgChip, size && styles[size])} src="/static/images/summersale.svg" style={style} />
  }
  if (color === 'trendhimclubexclusive') {
    return (
      <img alt="Trendhim Club Exclusive" className={clsx(styles.svgChip, size && styles[size])} src="/static/images/trendhimclubexclusive.svg" style={style} />
    )
  }
  if ((lateSeasonSvgTag && color === 'lateseasonsale') || color === 'lateseasonsalesvg') {
    return (
      <img alt="Late Season Sale" className={clsx(styles.svgChip, size && styles[size])} src="/static/images/lateseasonsale.svg" style={style} />
    )
  }

  return (
    <div
      className={clsx(
        styles.chip,
        color === 'grey' && styles.grey,
        color === 'greyV2' && styles.greyV2,
        (color === 'red' || color === '20' || (color === 'sale')) && styles.error,
        color === 'error' && styles.error,
        color === 'black' && styles.black,
        color === 'event' && styles.event,
        color === 'blue' && styles.blue,
        color && styles[color],
        size && styles[size],
        className,
      )}
      style={style}
    >
      {saleTagTest && color === 'sale' ? 'Sale' : children}
    </div>
  )
}
